
import {getUserInfo,dropDownCompany,staff_role_list} from "@/api/manage"
export default {
    namespaced: true,
    state: {
        userInfo:'',
        companyList:'',
        companySelectItem:'',
        roleList:''
    },
    getters: {},
    mutations: {
        set_user_info(state,data){
            console.log(data,'set_user_info')
            state.userInfo=data
            localStorage.setItem('userInfo',JSON.stringify(data));
        },
        set_company_list(state,data){
            console.log(data,'set_company_list')
            state.companyList=data
            localStorage.setItem('companyList',JSON.stringify(data));
        },
        set_company_select_item(state,data){
            console.log(data,'set_company_select_item')
            state.companySelectItem=data
            localStorage.setItem('companySelectItem',JSON.stringify(data));
        },
        set_role_list(state,data){
            console.log(data,'set_role_list')
            state.roleList=data
            localStorage.setItem('roleList',JSON.stringify(data));
        },
    },
    actions: {
        async get_user_info({commit, dispatch}) {
            let res = await getUserInfo()
            if(res.code===200){
                commit("set_user_info", res.data)
                await dispatch('get_role_list');
            }else{
                console.log(res.msg)
            }
        },
        async get_company_list({commit, dispatch}) {
            let res = await dropDownCompany()
            if(res.code===200){
                commit("set_company_list", res.data)
                commit("set_company_select_item", res.data[0])
            }else{
                console.log(res.msg)
            }
        },
        async get_role_list({commit, dispatch}) {
            let res = await staff_role_list()
            if(res.code===200){
                commit("set_role_list", res.data)
            }else{
                console.log(res.msg)
            }
        },
        async get_company_select_item({commit},data) {
            commit("set_company_select_item", data)
        }

    }
}